/**
 * Environment configuration for React app
 * Create React App replaces process.env.* at build time
 */

// Environment variables with defaults
export const ENV = {
  ACCESS_KEY: process.env.REACT_APP_ACCESS_KEY || "",
  ACTION_KEY: process.env.REACT_APP_ACTION_KEY || "",
  GATEWAY_URL:
    process.env.REACT_APP_USE_PROXY === "true"
      ? process.env.REACT_APP_PROXY_GATEWAY_URL
      : process.env.REACT_APP_GATEWAY_URL,
  BACKEND_URL:
    process.env.REACT_APP_USE_PROXY === "true"
      ? process.env.REACT_APP_PROXY_BACKEND_URL
      : process.env.REACT_APP_BACKEND_URL,
  API_TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || "30000"),
  USE_PROXY: process.env.REACT_APP_USE_PROXY === "true",
  USE_MOCK_DATA: process.env.REACT_APP_USE_MOCK_DATA === "true",
  NODE_ENV: process.env.NODE_ENV || "development",
};

// Helper functions
export const getAccessKey = () => ENV.ACCESS_KEY;
export const getActionKey = () => ENV.ACTION_KEY;
export const getGatewayUrl = () => ENV.GATEWAY_URL;
export const getBackendUrl = () => ENV.BACKEND_URL;
export const isProxyEnabled = () => ENV.USE_PROXY;
export const isMockDataEnabled = () => ENV.USE_MOCK_DATA;
export const isDevelopment = () => ENV.NODE_ENV === "development";
export const isProduction = () => ENV.NODE_ENV === "production";

// Validation
export const validateEnvironment = () => {
  const errors: string[] = [];

  if (!ENV.ACCESS_KEY) {
    errors.push("REACT_APP_ACCESS_KEY is not set");
  }

  if (!ENV.ACTION_KEY) {
    errors.push("REACT_APP_ACTION_KEY is not set");
  }

  if (errors.length > 0) {
    console.error("⚠️ Environment configuration errors:");
    errors.forEach((error) => console.error(`  - ${error}`));
    return false;
  }

  return true;
};

// Log configuration (masked)
export const logConfiguration = () => {
  console.log("Environment Configuration:", {
    ACCESS_KEY: ENV.ACCESS_KEY ? `***${ENV.ACCESS_KEY.slice(-4)}` : "NOT SET",
    ACTION_KEY: ENV.ACTION_KEY ? `***${ENV.ACTION_KEY.slice(-4)}` : "NOT SET",
    GATEWAY_URL: ENV.GATEWAY_URL,
    USE_PROXY: ENV.USE_PROXY,
    USE_MOCK_DATA: ENV.USE_MOCK_DATA,
    NODE_ENV: ENV.NODE_ENV,
  });
};

// Initialize and validate on load
if (isDevelopment()) {
  logConfiguration();
  validateEnvironment();
}
